<template>
  <nav
      class="navbar navbar-expand-lg navigation fixed-top sticky"
      id="navbar"
  >
    <div class="container">
      <a class="navbar-logo" href="/">
        <img
            src="@/assets/images/favicon.svg"
            alt
            height="35"
            class="logo logo-dark"
        />
        <img
            src="@/assets/images/favicon.svg"
            alt
            height="35"
            class="logo logo-light"
        />
      </a>

      <button
          type="button"
          class="btn btn-sm px-3 font-size-16 d-lg-none header-item"
          data-toggle="collapse"
          data-target="#topnav-menu-content"
          @click="toggleMenu()"
      >
        <img src="@/assets/images/covecoders/icon/menu.png" alt="" />
      </button>

      <div class="collapse navbar-collapse" id="topnav-menu-content">
        <ul
            class="navbar-nav ml-auto"
            id="topnav-menu"
            v-scroll-spy-active="{ selector: 'a.nav-link' }"
        >
          <li class="nav-item">
            <a class="nav-link" href="/" style="color:#000">
              <b class="bold" v-if="activePage === 'home'">Home</b>
              <span v-else>Home</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="/curriculum" style="color:#000"
            >
              <b class="bold" v-if="activePage === 'curriculum'">Curriculum</b>
              <span v-else>Curriculum</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="/about" style="color:#000">
              <b class="bold" v-if="activePage === 'about'">About Us</b>
              <span v-else>About Us</span>
            </a>
          </li>
        </ul>

        <div class="ml-lg-2">
          <a href="/registration" class="btn-all w-xs">Join Now</a>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: "layout-header",
  props: ["activePage"],
  methods: {
    toggleMenu() {
      document.getElementById("topnav-menu-content").classList.toggle("show");
    },
  }
}
</script>

<style scoped>

</style>